<template>
    <v-card flat color="transparent" class="product-card" :class="'product-card--' + num" :href="href">
        <div class="img-wrap">
            <v-img :src="'/images/main/product-bg-' + num + '.png'" class="product-card__bg" />
            <v-img eager :src="'/images/main/product-' + num + '.png'" class="product-card__img" />
        </div>
        <u-tit-wrap-default class="tit-wrap--sm text-center">
            <u-tit-default class="tit--sm">{{ $t(name) }}</u-tit-default>
        </u-tit-wrap-default>
        <txt-primary class="text-center">
            <p class="product-card__tag">{{ $t(tag) }}</p>
            <p><slot name="txt" /></p>
        </txt-primary>
        <div class="btn-wrap btn-wrap--sm d-flex justify-center">
            <v-btn icon outlined color="primary" class="product-card__btn">
                <icon-arrow-secondary direction="right" size="small" />
            </v-btn>
        </div>
    </v-card>
</template>

<script>
import UTitWrapDefault from "@/components/publish/styles/typography/u-tit-wrap-default.vue";
import UTitDefault from "@/components/publish/styles/typography/u-tit-default.vue";
import TxtPrimary from "@/components/publish/parents/typography/txt-primary.vue";
import IconArrowSecondary from "@/components/publish/parents/icons/icon-arrow-secondary.vue";

export default {
    components: {
        UTitWrapDefault,
        UTitDefault,
        TxtPrimary,
        IconArrowSecondary,
    },
    props: {
        href: { type: String, default: "" },
        num: { type: String, default: "" },
        name: { type: String, default: "" },
        tag: { type: String, default: "" },
    },
};
</script>

<style lang="scss" scoped>
.product-card {
    .img-wrap {
        position: relative;
        margin-bottom: 24px;
        height: 366px;
        display: flex;
        justify-content: center;
        align-items: end;
    }
    &__bg {
        position: absolute;
        top: 0;
        left: 50%;
        -webkit-transform: translate(-50%, 0);
        -ms-transform: translate(-50%, 0);
        transform: translate(-50%, 0);
    }
    &__img {
        max-width: 160px;
        filter: drop-shadow(10px 10px 36px rgba(0, 0, 0, 0.25));
    }
    &__tag {
        font-weight: bold;
        line-height: 1.1;
    }
}
.product-card--01 .product-card__tag {
    color: var(--v-primary-base);
}
.product-card--02 .product-card__tag {
    color: var(--v-secondary-base);
}
.product-card--03 .product-card__tag {
    color: var(--v-accent-base);
}

@media (min-width: 1200px) {
    .product-card {
        -webkit-transition: all ease-out 0.2s;
        -ms-transition: all ease-out 0.2s;
        transition: all ease-out 0.2s;
        .img-wrap {
            margin-bottom: 34px;
        }
        &__bg {
            opacity: 0.2;
            -webkit-transition: all ease-out 0.2s;
            -ms-transition: all ease-out 0.2s;
            transition: all ease-out 0.2s;
        }
        &__img {
            -webkit-transition: all ease-out 0.2s;
            -ms-transition: all ease-out 0.2s;
            transition: all ease-out 0.2s;
        }
        &:hover {
            margin-top: -40px;
            padding-bottom: 40px;
            .product-card__bg {
                opacity: 1;
            }
            .product-card__img {
                max-width: 180px;
            }
            .product-card__btn::before {
                opacity: 0.1;
            }
        }
    }
}
</style>
